import { COVERGO_SAAS_PROD } from "../consts.js"

export const xtrategize = {
	// CoverGo PROD
	"xtrategize-dev-studio.quote.hk": {
		appConfig: { tenantId: "xtrategize_playground", appId: "covergo_crm" },
		envConfig: COVERGO_SAAS_PROD
	}
}
